<template>
	<div class="px-0 pb-0 mb-5 container-fluid step-content" id="marker-accordion-sms-hub">
		<div class="mb-3 row justify-content-between">
			<div class="col-12 d-flex justify-content-between header">
				<div class="mb-3 col-12 col-md-8 d-flex align-items-center">
					<h2 class="mr-3 title">SMS Hub</h2>
					<actions-dropdown></actions-dropdown>
				</div>
			</div>
		</div>

		<div class="in-sms-belt">
			<div v-if="virtualNumber == null">
				<h5 class="mt-5 text-center text-muted">{{ virtualNumberText }}</h5>
			</div>

			<div v-else id="sms_table" class="in-sms-belt amb-border-top d-flex">
				<div
					id="smsContent"
					infinite-scroll-disabled="busy"
					infinite-scroll-distance="20"
					class="bg-transparent tab-content in-email-col border-left-0"
				>
					<div id="assigned-tab" role="tabpanel" aria-labelledby="assigned" class="p-0 tab-pane fade active show">
						<!-- Applicant Contacts -->
						<div class="d-flex flex-column flex-grow-1">
							<h6 class="p-3 m-0">Applicants</h6>
							<hr class="m-0" />
							<div v-if="Object.keys(active_applicants).length > 0">
								<div v-for="applicant in active_applicants" :key="applicant.id">
									<button
										v-if="selectedName && selectedName == applicant.full_name"
										@click="readSMS(applicant, true)"
										class="p-3 text-left selected-blue-rect sms-selected"
									>
										{{ applicant.full_name }}
										<br />
										<span>{{ applicant.phone }}</span>
									</button>

									<button v-else @click="readSMS(applicant, true)" class="p-3 text-left selected-white-rect sms-unselected">
										{{ applicant.full_name }}
										<br />
										<span>{{ applicant.phone }}</span>
									</button>
								</div>
							</div>
							<div v-else>
								<h5 class="mt-5 text-center text-muted">
									No Applicants
									<br />
									Phone Number
								</h5>
							</div>
						</div>

						<hr class="m-0" />

						<!-- OPEN: Dealer Contacts -->
						<div class="d-flex flex-column flex-grow-1" v-if="dealerContacts.length > 0">
							<h6 class="p-3 m-0">Dealers</h6>
							<hr class="m-0" />
							<div>
								<div v-for="contact in dealerContacts" :key="contact.id">
									<button
										v-if="selectedName && selectedName == contact.full_name"
										@click="readSMS(contact, true)"
										class="p-3 text-left selected-blue-rect sms-selected"
									>
										{{ contact.full_name }}
										<br />
										<span>{{ contact.phone }}</span>
									</button>
									<button v-else @click="readSMS(contact, true)" class="p-3 text-left selected-white-rect sms-unselected">
										{{ contact.full_name }}
										<br />
										<span>{{ contact.phone }}</span>
									</button>
								</div>
							</div>
						</div>
						<!-- STOP: Dealer Contacts -->

						<!-- OPEN: Private Seller Contacts -->
						<div class="d-flex flex-column flex-grow-1" v-if="sellerContacts.length > 0">
							<h6 class="p-3 m-0">Private Seller</h6>
							<hr class="m-0" />
							<div>
								<div v-for="contact in sellerContacts" :key="contact.id">
									<button
										v-if="selectedName && selectedName == contact.full_name"
										@click="readSMS(contact, true)"
										class="p-3 text-left selected-blue-rect sms-selected"
									>
										{{ contact.full_name }}
										<br />
										<span>{{ contact.phone }}</span>
									</button>
									<button v-else @click="readSMS(contact, true)" class="p-3 text-left selected-white-rect sms-unselected">
										{{ contact.full_name }}
										<br />
										<span>{{ contact.phone }}</span>
									</button>
								</div>
							</div>
						</div>
						<!-- STOP: Private Seller Contacts -->

                        <hr class="m-0" />

						<!-- OPEN: referrer Contacts -->
						<div class="d-flex flex-column flex-grow-1" v-if="referrerContacts.length > 0">
							<h6 class="p-3 m-0">Referrer</h6>
							<hr class="m-0" />
							<div>
								<div v-for="contact in referrerContacts" :key="contact.id">
									<button
										v-if="selectedName && selectedName == contact.full_name"
										@click="readSMS(contact, true)"
										class="p-3 text-left selected-blue-rect sms-selected"
									>
										{{ contact.full_name }}
										<br />
										<span>{{ contact.phone }}</span>
									</button>
									<button v-else @click="readSMS(contact, true)" class="p-3 text-left selected-white-rect sms-unselected">
										{{ contact.full_name }}
										<br />
										<span>{{ contact.phone }}</span>
									</button>
								</div>
							</div>
						</div>
						<!-- STOP: referrer Contacts -->
                        <hr class="m-0" />

                        <!-- Unknown Contacts -->
						<div v-if="Object.keys(unknown_applicants).length > 0" class="d-flex flex-column flex-grow-1">
							<h6 class="p-3 m-0">Unknown Contacts</h6>
							<hr class="m-0" />
							<div>
								<div v-for="applicant in unknown_applicants" :key="applicant.id">
									<button
										v-if="selectedName && selectedName == applicant.full_name"
										@click="readSMS(applicant, true)"
										class="p-3 text-left selected-blue-rect sms-selected"
									>
										{{ applicant.full_name }}
										<br />
										<span>{{ applicant.phone }}</span>
									</button>

									<button v-else @click="readSMS(applicant, true)" class="p-3 text-left selected-white-rect sms-unselected">
										{{ applicant.full_name }}
										<br />
										<span>{{ applicant.phone }}</span>
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div
					id="smsContent2"
					infinite-scroll-disabled="busy"
					infinite-scroll-distance="20"
					class="overflow-auto bg-white flex-grow-1"
				>
					<div id="assigned-tab" role="tabpanel" aria-labelledby="assigned" class="p-0 tab-pane fade active show">
						<div class="d-flex flex-column flex-grow-1 input-belt">
							<div v-if="applicant != null" id="sms-input-number">
								<p class="my-2">{{ selectedName }} <{{ selectedPhoneNumber }}></p>
							</div>

							<div id="msg-content" class="msg-container">
								<div v-for="(item, index) in selectedMessage" :key="index">
									<p class="mt-3 datep">{{ index }}</p>

									<div class="sms-content" v-for="sms in item" :key="sms.id">
										<div v-if="sms.is_outbound == 1" class="sms-is-outbound position-relative">
											<p class="mb-0 text-white">
                                                <sms-message :message="sms.message" />
                                            </p>
											<p class="mb-0 timestamp">
												<small>{{ sms.date_sent | moment("hh:mm A") }}</small>
											</p>
											<div
												class="position-absolute out-arrow"
												style="background-image: url('/images/decorations/tail-blue.svg')"
											></div>
										</div>

										<div v-else class="sms-is-inbound position-relative">
											<p class="mb-0 text-dark">
                                                <sms-message :message="sms.message" />
                                            </p>
											<p class="mb-0 timestamp">
												<small>{{ sms.date_sent | moment("hh:mm A") }}</small>
											</p>
											<div
												class="position-absolute in-arrow"
												style="background-image: url('/images/decorations/tail-grey.svg')"
											></div>
										</div>
									</div>
								</div>
								<div class="sms-content">
									<div v-if="newTextMessage != null" class="sms-is-outbound position-relative">
										<p class="mb-0 text-dark">
                                            <sms-message :message="newTextMessage" />
                                        </p>
										<p class="mb-0 timestamp">
											<small>{{ date_sent | moment("hh:mm A") }}</small>
										</p>
										<div
											class="position-absolute out-arrow"
											style="background-image: url('/images/decorations/tail-blue.svg')"
										></div>
									</div>
								</div>
								<p id="sms-send-response">{{ sms_status }}</p>
							</div>

							<!-- </div>  -->
							<!-- end of msg-content -->

							<div class="sms-input-group input-group" v-if="applicant != null">
								<el-select
									v-if="Ambition.useEmailBuilder()"
									@change="onSelectTemplate"
									v-model="textmessageSelected"
									class="mb-2 w-100"
									placeholder="Select SMS Template"
									clearable
								>
									<el-option
										v-for="template in sms_templates"
										:key="template.uid"
										:label="template.name"
										:value="template.uid"
									></el-option>
								</el-select>

								<el-select
									v-else
									@change="onSelectTemplate"
									v-model="textmessageSelected"
									class="mb-2 w-100"
									placeholder="Select SMS Template"
									clearable
								>
									<el-option
										v-for="template in sms_templates"
										:key="template.id"
										:label="template.name"
										:value="template.id"
									></el-option>
								</el-select>

                                <div class="textarea-word-limit">

                                    <div v-if="(smsTextLength > smsTextMaxLength) && isBlankTemplate" class="text-danger">Error: This text message has exceeded the maximum character limit.</div>
                                    <div v-else-if="(smsTextLength > smsTextMaxLength) && !isBlankTemplate" class="text-warning">Warning: The message is over 320 characters. We recommend keeping SMS messages to 320 characters or fewer to achieve a better response rate.</div>

                                    <el-input v-if="isBlankTemplate"
                                        :autosize="{ minRows: 6 }"
                                        type="textarea"
                                        class="w-100"
                                        :class="[{ 'oversize': smsTextLength > smsTextMaxLength }]"
                                        v-model="textmessage"
                                        placeholder="Type message here"
                                        show-word-limit
                                    ></el-input>

                                    <el-input v-else-if="!isBlankTemplate"
                                        :autosize="{ minRows: 6 }"
                                        type="textarea"
                                        class="w-100"
                                        :class="[{ 'oversize-warning': smsTextLength > smsTextMaxLength }]"
                                        v-model="textmessage"
                                        placeholder="Type message here"
                                        show-word-limit
                                    ></el-input>

                                    <span v-if="cappedSmsTemplate && isBlankTemplate" :class="['textarea-word-limit__count', { 'text-danger': smsTextLength > smsTextMaxLength }]">
                                        <span>{{ smsTextLength }}</span>
                                        <span> / {{ smsTextMaxLength }}</span>
                                    </span>
                                    <span v-else-if="cappedSmsTemplate && !isBlankTemplate" :class="['textarea-word-limit__count', { 'text-warning': smsTextLength > smsTextMaxLength }]">
                                        <span>{{ smsTextLength }}</span>
                                        <span> / {{ smsTextMaxLength }}</span>
                                    </span>
                                </div>

								<div id="sms-send-option">
									<button :disabled="(!textMessageUnderMaximumLength || !textmessage) && isBlankTemplate" @click="sendMessage()" class="btn-light-blue">Send Message</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
	import { Message } from "element-ui"
    import SMSMessage from "./SMSMessage.vue"
	import { mapState, mapGetters } from "vuex"
	export default {
    name: "SMSHub",
        components: {
            'sms-message': SMSMessage
        },
		props: ["showTitle"],
		data() {
			return {
				dateToday: '{{ date("Y-m-d") }}',
				busy: false,
				loading: false,
				applications: [],
				page: 1,
				application: null,
				headers: null,
				smshub: [],
				messages: [],
				selectedPhoneNumber: null,
				selectedName: null,
				selectedMessage: null,
				delivered: "",
				sms_status: null,
				sms_templates: [],
				textmessage: null,
				active_applicants: [],
                unknown_applicants: [],
                unknown_applicant_count: 0,
				is_new: 0,
				newSelectedPhoneNumber: null,
				textmessageSelected: null,
				newTextMessage: null,
				virtualNumber: null,
				virtualNumberText: "",
				date_sent: null,
				applicant: null,

				dealerContacts: [],
				dealerId: null,
				sellerContacts: [],
                referrerContacts: [],

				smsTemplatesLoading: true,
                selectedTextMessage: {}
			}
		},
		computed: {
			...mapGetters({
				smsTemplates: "builderEmail/getActiveSmsTemplates",
                smsTextMaxLength: "builderEmail/smsTextMaxLength",
			}),
            cappedSmsTemplate() {
                if (_.isEmpty(this.selectedTextMessage) || _.has(this.selectedTextMessage, 'name', false)) {
                    return true
                }
                return false
            },
            smsTextLength() {
                let smsText = this.textmessage
                if (smsText) {
                    let smsTextCount = _.size(smsText)
                    let lineBreakCount = _.size(smsText.match(/\n/g) || [])
                    return parseInt(smsTextCount) + parseInt(lineBreakCount)
                }
                return 0
            },
            isBlankTemplate() {
                if (['Blank SMS'].includes(this.selectedTextMessage.name)) {
                    return true
                }
                return false
            },
            textMessageUnderMaximumLength() {
                if (this.cappedSmsTemplate) {
                    let smsText = this.textmessage
                    if (smsText) {
                        let smsTextCount = _.size(smsText)
                        let lineBreakCount = _.size(smsText.match(/\n/g) || [])
                        return (parseInt(smsTextCount) + parseInt(lineBreakCount)) <= this.smsTextMaxLength
                    }
                }
                return true
            },
		},
		mounted() {
			this.smsTemplatesLoading = true

			// getting sms templates

			if (Ambition.useEmailBuilder()) {
				this.$store.dispatch("builderEmail/setAllSmsTemplates").then((res) => {
					this.smsTemplatesLoading = false
					this.sms_templates = this.smsTemplates.filter((smsTemplate) => smsTemplate.type === "single" && smsTemplate.action !== 'app-form-pack')
				})
			} else {
				axios
					.get(
						// `/api/settings/sms_templates/`+this.application.id,
						`/api/settings/sms_templates/`,
						this.tenantHeaders()
					)
					.then((res) => {
						this.sms_templates = res.data
					})
					.catch((err) => {
						console.error(err)
					})
			}
		},
		created() {
			this.page = 1 // reset to page one on every page call;
			this.application = this.$store.getters.initAppData
            if ( this.application.referrer ){
                let referrerContact = {
                    id: this.application.referrer.user.id,
                    email: this.application.referrer.user.email,
                    full_name: this.application.referrer.user.full_name,
                    phone: this.application.referrer.user.phone,
                    type: "referrer",
                }
                this.referrerContacts.push(referrerContact)
            }

			axios
				.get(`/api/applications/${this.application.id}/sms`, this.tenantHeaders())
				.then((res) => {
					this.messages = res.data["smsmessages"]
					this.active_applicants = res.data["active_applicants"]

                    Object.keys(this.messages).forEach((name) => {
                        if (!this.active_applicants.map(applicant => applicant.full_name).includes(name)) {

                            let extraContacts = [...this.sellerContacts, ...this.dealerContacts, ...this.referrerContacts]

                            if (!extraContacts.some(contact => contact.phone == name)) {
                                this.unknown_applicant_count++
                                this.unknown_applicants.push({
                                    full_name: "Unknown Contact " + this.unknown_applicant_count,
                                    phone: name
                                })
                            }
                        }
                    })

					this.virtualNumber = res.data["virtual_number"]
					if (this.virtualNumber == null || this.active_applicants.length == 0) {
						if (this.virtualNumber == null) {
							this.virtualNumberText = "No virtual number saved for this tenant. Please contact administrator."
						} else {
							this.virtualNumber = null
							this.virtualNumberText = "No applicants yet."
						}
					}
				})
				.catch((err) => {
					console.error(err)
				})

			Echo.private("message_received." + this.application.id).listen(".received", (e) => {
				if (this.applicant != null) {
					axios
						.get(`/api/applications/${this.application.id}/sms`, this.tenantHeaders())
						.then((res) => {
							this.messages = res.data["smsmessages"]
							this.readSMS(this.applicant, false)
						})
						.catch((err) => {
							console.error(err)
						})
				}
			})
		},
		activated() {
			this.getDealerContacts()
		},
		methods: {
			async updateApplication() {
				const headers = { Authorization: "Bearer " + this.$store.getters.token }
				const appId = this.$store.getters.initAppData.id

				// Get current dealer / seller data first
				return axios
					.get(`/api/application/${appId}`, {
						headers,
					})
					.then((res) => {
						this.application = res.data
						console.debug("GET APPLICATION", res.data)
					})
					.catch((e) => {
						throw Error(e)
					})
			},

			async getDealerContacts() {
				const headers = { Authorization: "Bearer " + this.$store.getters.token }
				const appId = this.$store.getters.initAppData.id

				// Clear dealer / seller contacts
				this.dealerContacts = []
				this.sellerContacts = []

				await this.updateApplication()

				// Seller type information
				const invoice = this.application.invoice_information
				const invoiceData = Array.isArray(invoice) && invoice.length > 0 ? invoice[0] : invoice || {}
				const contactId =
					typeof invoiceData === "object" ? (invoiceData.type === "customer" ? invoiceData.contact.user_id : invoiceData.id) : false
				const contactType = typeof invoiceData === "object" ? invoiceData.type : false
				const isDealer = contactType === "dealer"
				// console.debug("GET CONTACT", { invoice, invoiceData, contactId, contactType })
				// return

				// Get the private or dealer seller contact information
				if (isDealer) {
					// Get dealer contacts
					this.dealerId = invoiceData.contact.dealer_id

					// Get dealer contacts based on ID
					axios
						.get(`/api/applications/asset-seller/${appId}/dealers/${this.dealerId}`, {
							params: {},
							headers,
						})
						.then((res) => {
                            if (!_.isEmpty(_.get(res.data, 'contacts', []))) {
                                res.data.contacts.forEach((e) => {
                                    const contact = {
                                        id: e.id,
                                        email: e.email,
                                        full_name: e.name,
                                        phone: e.mobile,
                                        type: "dealer",
                                    }
                                    if (e.id === contactId) this.dealerContacts.push(contact)
                                })
                            }

						})
						.catch((e) => {
							throw Error(e)
						})
				} else {
					// Get non-dealer contacts
					const privateSellerContactId = invoiceData.id || false

					await axios
						.get(`/api/applications/asset-seller/${appId}/contacts`, {
							params: { id: privateSellerContactId },
							headers,
						})
						.then((res) => {
                            if (!_.isEmpty(_.get(res, 'data', []))) {
                                res.data.forEach((e) => {
                                    const contact = {
                                        id: e.id,
                                        email: e.email,
                                        full_name: e.full_name,
                                        phone: e.phone,
                                        private_seller: true,
                                        type: "seller",
                                    }
                                    if (e.id === contactId) this.sellerContacts.push(contact)
                                })
                            }
						})
						.catch((e) => {
							throw Error(e)
						})
				}
			},
			async getApplications(query) {
				let url = `/api/email/search/applications?q=${query}`
				this.loading = true
				axios.get(url, this.tenantHeaders()).then((res) => {
					this.loading = false
					this.applications = res.data
				})
			},
			tenantHeaders() {
				let tenantHeaders = {
					headers: { Authorization: "Bearer " + this.$store.getters.token },
				}

				return tenantHeaders
			},
			readSMS(applicant, resetSms) {
				this.applicant = applicant
				this.selectedName = applicant.full_name
				this.selectedPhoneNumber = applicant.phone
				$("#text-message").val("")

				const selectedMessage = _.get(this.messages, this.selectedName, _.get(this.messages, this.selectedPhoneNumber, false))

				if (selectedMessage) {
					this.selectedMessage = selectedMessage

                    if (resetSms) {
                        this.textmessage = ""
                        this.sms_status = null
                        this.textmessageSelected = null
                        this.is_new = 0
                        this.newTextMessage = null
                    }

					$("#msg-content")
						.stop()
						.animate(
							{
								scrollTop: _.get($("#msg-content"), '0.scrollHeight'),
							},
							450
						)

					setTimeout(function () {
						$("#msg-content")
							.stop()
							.animate(
								{
									scrollTop: _.get($("#msg-content"), '0.scrollHeight'),
								},
								450
							)
					}, 2000)
				} else {
					this.is_new = 1
					this.selectedMessage = null
					this.textmessageSelected = null
					this.newTextMessage = null
					this.sms_status = null
				}
			},

			sendMessage() {
				var to = this.selectedPhoneNumber
				var textmessage = this.textmessage

				if (to == null || to == "") {
					swal({
						text: "Please select recipient",
						type: "warning",
						allowOutsideClick: false,
					})
				} else if (textmessage != null && textmessage != "") {
					this.newTextMessage = textmessage.replace(/(?:\r\n|\r|\n)/g, "<br>")
					this.sms_status = "Sending"

					$("#msg-content")
						.stop()
						.animate(
							{
								scrollTop: _.get($("#msg-content"), '0.scrollHeight'),
							},
							450
						)

					this.textmessage = null
					this.textmessageSelected = null

					axios
						.post(
							`/api/applications/${this.application.id}/sms/send`,
							{
								message: textmessage,
								to: to,
							},
							this.tenantHeaders()
						)

						.then((res) => {
							if (res.data["status"] == 0) {
								this.sms_status = "Delivered"
								this.date_sent = res.data["date_sent"]
							}

							this.messages = res.data["smsmessages"]

							$("#msg-content")
								.stop()
								.animate(
									{
										scrollTop: _.get($("#msg-content"), '0.scrollHeight')
									},
									450
								)

							if (this.applicant != null) {
								axios
									.get(`/api/applications/${this.application.id}/sms`, this.tenantHeaders())
									.then((res) => {
										this.messages = res.data["smsmessages"]
										this.readSMS(this.applicant, true)
									})
									.catch((err) => {
										console.error(err)
									})
							}
						})
						.catch((err) => {
							console.error(err)

							swal({
								text: "Error sending message",
								type: "warning",
								allowOutsideClick: false,
							})
						})
				}
			},
			onSelectTemplate() {
				var applicant_id = null
				if (this.applicant != null) applicant_id = this.applicant.id

				const private_seller = this.applicant.private_seller === true

				let emailSendsTo = "applicant"

				if (_.get(this.applicant, "type")) {
					emailSendsTo = _.get(this.applicant, "type")
				}

				axios
					.post(
						`/api/settings/sms-get-template/` + this.textmessageSelected,
						{
							// email builder
							useBuilder: Ambition.useEmailBuilder(),
							recipientId: applicant_id,
							emailSendsTo: emailSendsTo,
							applicationId: this.application.id,
							// old syntax
							application_id: this.application.id,
							applicant_id: applicant_id,
							private_seller: private_seller,
						},
						this.tenantHeaders()
					)
					.then((res) => {
                        this.selectedTextMessage = res.data
						this.textmessage = this.selectedTextMessage.body
					})
					.catch((err) => {
						console.error(err)

						swal({
							text: "Error getting template",
							type: "warning",
							allowOutsideClick: false,
						})
					})
			},
		},
	}
</script>


<style lang="scss">
	.current {
		background-color: #eceff1;
	}

    .textarea-word-limit {
        position: relative;
        width: 100%;

        .textarea-word-limit__count {
            position: absolute;
            right: 0;
            bottom: 0;
            padding: 10px;
            font-size: 12px;
            color: #909399;
            pointer-events: all;
        }
    }
</style>
